module.exports = __webpack_public_path__ + "static/IMG_0089-0a23b09e29cbc9e7f310d5b76a631a52.jpg";